import { IMemberFileResponse } from "@wingspanhq/files/dist/lib/interfaces/api/file";

export const selectorIsFileVisibleByUserId = (
  userId: string,
  userRoles?: IMemberFileResponse["userRoles"]
) => {
  return userRoles?.viewerIds?.includes(userId);
};
